import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import { put, takeEvery } from 'redux-saga/effects';

import {
  NewRequestReservationActionType,
  sendRequestReservationAnswerError,
  sendRequestReservationAnswerSuccess,
  sendReservationRequestResponse,
} from '../../actions/reservation/realTimeReservation';
import getPublicResponse from '../getPublicResponse';

function* requestReservationAnswerSaga(action: NewRequestReservationActionType) {
  const ReservationRequestAnswerDto = { accepted: action.payload.accepted, uuid: action.payload.guestUuid };
  const response = yield getPublicResponse(PublicServerPlaceEvent.getReservationRequestAnswer, ReservationRequestAnswerDto);
  const { status } = response;
  if (status != 'ok') {
    yield put(sendRequestReservationAnswerError());
  } else {
    yield put(sendRequestReservationAnswerSuccess());
  }
}

export default function* watchRequestReservationAnswerSaga() {
  yield takeEvery(sendReservationRequestResponse, requestReservationAnswerSaga);
}
